import { Button } from '@backyard-ui/core'
import { Text } from '@leroy-merlin-br/backyard-react'
import { useMyOrdersContext } from 'frontendMyOrders/context/MyOrdersContext'
import type { ThreadsType } from 'frontendMyOrders/plugins/Chat/MarketPlace/types'

import { Shift } from '../Shift'
import { ShippingInfo } from '../ShippingInfo'
import * as S from './styled'

type HeaderProps = {
  type: string
  quantity: number
  deliveryDate: {
    date: string
    message: string
  }
  shift: string
  isStandaloneService: boolean
  orderId?: string
  marketplaceOrder?: string
  shopName?: string
  threads?: ThreadsType
}

const Header = ({
  type,
  quantity,
  deliveryDate,
  shift,
  isStandaloneService,
  orderId,
  marketplaceOrder,
  shopName,
  threads
}: HeaderProps) => {
  const { plugins } = useMyOrdersContext()

  const { MarketplaceChat } = plugins

  const hasNewMessage = threads?.some(thread => thread.hasNewMessage)

  return (
    <S.Wrapper>
      <S.Type>
        <Text as="strong" size="mega" isBold noMargin color="g700">
          {type}
        </Text>
      </S.Type>

      <S.Quantity>
        <Text size="kilo" noMargin>
          Itens
        </Text>
        <Text as="strong" size="kilo" isBold noMargin>
          {quantity}
        </Text>
      </S.Quantity>

      <S.Shipping>
        <ShippingInfo
          type={type}
          date={deliveryDate?.date}
          isStandaloneService={isStandaloneService}
        />
      </S.Shipping>

      <S.Shift>{shift && <Shift type={type} shift={shift} />}</S.Shift>

      <S.Chat>
        {MarketplaceChat && orderId && shopName && marketplaceOrder && (
          <Button size="xs" asChild>
            {hasNewMessage ? (
              <S.NotifyButton
                href={`/meus-pedidos/falar-com-vendedor/${orderId}/shipment/${marketplaceOrder}/thread`}>
                Falar com vendedor
              </S.NotifyButton>
            ) : (
              <a
                href={`/meus-pedidos/falar-com-vendedor/${orderId}/shipment/${marketplaceOrder}/thread`}>
                Falar com vendedor
              </a>
            )}
          </Button>
        )}
      </S.Chat>
    </S.Wrapper>
  )
}

export default Header
